import rxios from '../common/rxios'
import { map } from 'rxjs/operators'

export const i18nMessageService = {
  getMessages$() {
    return rxios
    .get(`${domain.homepage}/i18n-api/i18n/messages/bundle?category=HOMEPAGE&bundleFormat=VUE_I18N`)
    .pipe(map(response => response.data.messages))
  }
}

